import { Component, Input } from '@angular/core';
import { TranslationService } from '@proximus/ng-common';
import { tap } from 'rxjs/operators';
import { CryptoService } from '../../../../services/crypto.service';

@Component({
  selector: 'mprd-fiber-migration',
  templateUrl: 'fiber-migration.component.html',
})
export class FiberMigrationComponent {
  @Input() isOutOfPack = false;
  @Input() isSE: boolean;
  @Input() isRES: boolean;
  @Input() pack: any;
  @Input() lomKey: string | undefined;
  @Input() greyBackground = false;

  constructor(
    private translationService: TranslationService,
    private cryptoService: CryptoService,
  ) {}

  onClick(): void {
    const product = this.pack?.coreProducts?.find(
      (product) => product?.isEshareFiberEligible,
    );
    const isEshareEnable =
      this.translationService.getTranslatedValueFor('eshare.fiber.enable') ===
      'true';
    const token = product?.eshareToken;
    const swapScenario = product?.eshareSwapScenario;

    if (isEshareEnable && token) {
      this.redirectToEshareFiberUrl(token, swapScenario);
    } else {
      this.redirectToCtaProductUrl();
    }
  }

  private redirectToEshareFiberUrl(token: string, swapScenario: string): void {
    const dialogUrl = this.translationService.getTranslatedValueFor(
      `eshare.fiber.${swapScenario}.url`,
    );

    let url = dialogUrl.split('?')[0] || dialogUrl;
    let query = dialogUrl.split('?')[1] || '';

    this.cryptoService
      .codeGenerator(token)
      .pipe(tap((code) => {
        query = query
          ? `token=${code}&${query}`
          : `token=${code}`;

        window.open(`${url}?${query}`, '_self')
      }))
      .subscribe();
  }

  private redirectToCtaProductUrl(): void {
    const link = this.translationService.getTranslatedValueFor(this.getLink());
    if (link) {
      const mpcUuid = this.isOutOfPack
        ? this.pack?.groupMpcUuid
        : this.pack?.mpcUuid;
      sessionStorage.setItem(
        'fiberSwitch',
        JSON.stringify({ lomKey: this.lomKey, mpcUuid }),
      );
      window.open(link, '_self');
    }
  }

  private getLink(): string {
    if (this.isSE) {
      if (this.isFiberRESEligibleInPack()) {
        return 'products.overview.flex-fiber-eligibility-cta-SE-RES-inPack';
      }
      if (this.isFiberRESEligibleOutOfPack()) {
        return 'products.overview.flex-fiber-eligibility-cta-SE-RES-outOfPack';
      }
      if (this.isOutOfPack) {
        return 'products.overview.flex-fiber-eligibility-cta-SE-outOfPack';
      }
      return 'products.overview.flex-fiber-eligibility-cta-SE-inPack';
    } else if (this.isRES) {
      if (this.isOutOfPack) {
        return 'products.overview.flex-fiber-eligibility-cta-RES-outOfPack';
      }
      return 'products.overview.flex-fiber-eligibility-cta-RES-inPack';
    }
  }

  private isFiberRESEligibleInPack(): boolean {
    return this.pack?.coreProducts?.some(
      (product) => product?.isResFiberEligible,
    );
  }

  private isFiberRESEligibleOutOfPack(): boolean {
    return this.pack?.nonCoreProducts?.some(
      (product) => product?.isResFiberEligible,
    );
  }
}
